import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from '../../styles/common/TermsModal.module.css';
import modalStyles from '../../styles/common/Modal.module.css';

interface TermsModalProps {
    show: boolean;
    onHide: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({
    show,
    onHide,
}) => {
    const brandName = process.env.REACT_APP_BRAND_NAME || "elPaket";

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            className={styles.termsModal}
            contentClassName={styles.scaleIn}
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title as="h3" className={modalStyles.modalTitle}>
                    Términos y Condiciones
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="terms-content">
                    <p>
                        Bienvenido a {brandName}, una marca comercial y plataforma de servicios logísticos operada por EnviarLatam LLC ("EnviarLatam", "{brandName}" o la "Empresa"), sociedad constituida conforme a las leyes del Estado de Florida, Estados Unidos.
                    </p>
                    <p>
                        Los presentes Términos y Condiciones regulan el acceso y uso del sitio web, la plataforma y los servicios de recepción, almacenamiento, transporte, gestión logística y entrega de paquetes ofrecidos por la Empresa.
                    </p>
                    <p>
                        Al registrarse, acceder al sitio web o utilizar cualquiera de nuestros servicios, el Cliente declara haber leído, comprendido y aceptado estos Términos y Condiciones.
                    </p>

                    <h5>1. Servicios</h5>
                    <p>EnviarLatam LLC, a través de su marca {brandName}, presta servicios de:</p>
                    <ul>
                        <li>Recepción de paquetes.</li>
                        <li>Transporte internacional.</li>
                        <li>Gestión logística.</li>
                        <li>Entrega de mercancías.</li>
                    </ul>
                    <p>La disponibilidad de los servicios podrá variar según el país de destino, restricciones operativas y disposiciones legales.</p>

                    <h5>2. Elegibilidad</h5>
                    <p>Para utilizar nuestros servicios, el Cliente declara que:</p>
                    <ul>
                        <li>Tiene al menos dieciocho (18) años de edad o cuenta con capacidad legal para contratar.</li>
                        <li>La información suministrada es verdadera, completa y actualizada.</li>
                        <li>Es el propietario de la mercancía o está debidamente autorizado para enviarla.</li>
                    </ul>

                    <h5>3. Registro y Cuenta</h5>
                    <p>Cuando sea necesario crear una cuenta, el Cliente será responsable de:</p>
                    <ul>
                        <li>Mantener la confidencialidad de sus credenciales.</li>
                        <li>Actualizar oportunamente su información.</li>
                        <li>Todas las actividades realizadas desde su cuenta.</li>
                    </ul>
                    <p>La Empresa podrá suspender o cancelar cuentas que contengan información falsa o sean utilizadas de manera fraudulenta.</p>

                    <h5>4. Declaración de la Mercancía</h5>
                    <p>El Cliente deberá declarar de forma correcta:</p>
                    <ul>
                        <li>descripción de los artículos;</li>
                        <li>cantidad;</li>
                        <li>valor comercial;</li>
                        <li>peso, cuando corresponda;</li>
                        <li>contenido real del envío;</li>
                        <li>Información del remitente y destinatario.</li>
                    </ul>
                    <p>Toda declaración falsa, incompleta o engañosa será responsabilidad exclusiva del Cliente.</p>

                    <h5>5. Mercancías Prohibidas o Restringidas</h5>
                    <p>No podrán transportarse mercancías cuyo envío esté prohibido o restringido por la legislación de Estados Unidos, o cualquier otro país involucrado en la operación. (ver Sección de Artículos Prohibidos)</p>
                    <p>La Empresa podrá rechazar, devolver, retener o entregar a las autoridades competentes cualquier envío que incumpla estas disposiciones.</p>

                    <h5>6. Derecho de Inspección</h5>
                    <p>Por razones de seguridad, prevención del fraude y cumplimiento normativo, el Cliente autoriza a la Empresa a inspeccionar, escanear, abrir o verificar cualquier paquete cuando resulte necesario o sea requerido por una autoridad competente.</p>

                    <h5>7. Aduanas</h5>
                    <p>Todos los envíos podrán ser inspeccionados por las autoridades aduaneras.</p>
                    <p>El Cliente será responsable de:</p>
                    <ul>
                        <li>la veracidad de la documentación presentada;</li>
                        <li>permisos especiales;</li>
                        <li>impuestos;</li>
                        <li>aranceles;</li>
                        <li>tasas gubernamentales;</li>
                        <li>sanciones derivadas de declaraciones incorrectas.</li>
                    </ul>
                    <p>La Empresa actúa como proveedor logístico y no tiene control sobre las decisiones adoptadas por las autoridades aduaneras.</p>

                    <h5>8. Tiempos de Tránsito</h5>
                    <p>Los tiempos de entrega publicados tienen carácter estimado.</p>
                    <p>La Empresa no garantiza fechas específicas de entrega y no será responsable por retrasos ocasionados por:</p>
                    <ul>
                        <li>procesos aduaneros;</li>
                        <li>inspecciones gubernamentales;</li>
                        <li>condiciones climáticas;</li>
                        <li>interrupciones del transporte;</li>
                        <li>huelgas;</li>
                        <li>fallas de terceros;</li>
                        <li>eventos de fuerza mayor;</li>
                        <li>cualquier circunstancia fuera de su control razonable.</li>
                    </ul>

                    <h5>9. Empaque</h5>
                    <p>El Cliente es responsable de entregar la mercancía debidamente embalada para soportar el transporte nacional e internacional.</p>
                    <p>La Empresa no responderá por daños ocasionados por embalajes inadecuados o insuficientes.</p>

                    <h5>10. Pérdidas, Daños y Reclamaciones</h5>
                    <p>Toda reclamación deberá presentarse por escrito dentro de los tres (3) días hábiles siguientes a la entrega de la mercancía.</p>
                    <p>La reclamación deberá estar acompañada de la documentación que la Empresa solicite para su evaluación.</p>
                    <p>No procederán reclamaciones cuando:</p>
                    <ul>
                        <li>el daño sea consecuencia de un embalaje inadecuado;</li>
                        <li>exista desgaste normal;</li>
                        <li>el daño provenga de la naturaleza propia del producto;</li>
                        <li>la mercancía haya sido declarada incorrectamente;</li>
                        <li>el daño haya sido ocasionado por autoridades gubernamentales o aduaneras.</li>
                    </ul>

                    <h5>11. Seguro</h5>
                    <p>Toda mercancía transportada estará amparada por una cobertura de seguro. El valor asegurado se determinará con base en el valor declarado por el Cliente, quien será responsable de suministrar de manera veraz dicha información y la documentación de respaldo requerida para su validación.</p>

                    <h5>12. Limitación de Responsabilidad</h5>
                    <p>En la máxima medida permitida por la legislación aplicable, la responsabilidad total de EnviarLatam LLC por cualquier reclamación relacionada con los servicios de {brandName} no excederá el menor de los siguientes valores:</p>
                    <ul>
                        <li>el valor declarado de la mercancía aceptado por la Empresa; o</li>
                        <li>el monto efectivamente pagado por el servicio correspondiente.</li>
                    </ul>
                    <p>En ningún caso la Empresa será responsable por daños indirectos, incidentales, especiales, ejemplares, punitivos o consecuenciales, incluyendo pérdida de ingresos, pérdida de negocios, lucro cesante, pérdida de datos o cualquier otro daño económico indirecto.</p>

                    <h5>13. Tarifas y Pagos</h5>
                    <p>Las tarifas vigentes serán las publicadas por la Empresa o informadas al Cliente al momento de contratar el servicio.</p>
                    <p>El Cliente acepta pagar todos los cargos aplicables, incluyendo servicios logísticos, almacenamiento, impuestos, aranceles y cualquier otro costo asociado al envío.</p>

                    <h5>14. Suspensión del Servicio</h5>
                    <p>La Empresa podrá rechazar, suspender o cancelar cualquier servicio cuando:</p>
                    <ul>
                        <li>exista sospecha de fraude;</li>
                        <li>se incumplan estos Términos y Condiciones;</li>
                        <li>una autoridad competente lo requiera;</li>
                        <li>el envío representa un riesgo para la operación o para terceros.</li>
                    </ul>

                    <h5>15. Propiedad Intelectual</h5>
                    <p>El sitio web, la marca {brandName}, logotipos, diseños, software, textos, imágenes y demás contenidos son propiedad de EnviarLatam LLC o de sus respectivos titulares y están protegidos por las leyes de propiedad intelectual aplicables.</p>
                    <p>Queda prohibida su reproducción, distribución o utilización sin autorización previa y por escrito.</p>

                    <h5>16. Privacidad</h5>
                    <p>La recopilación y tratamiento de los datos personales se realiza conforme a la Política de Privacidad de EnviarLatam LLC, la cual forma parte integral de estos Términos y Condiciones.</p>

                    <h5>17. Modificaciones</h5>
                    <p>EnviarLatam LLC podrá modificar estos Términos y Condiciones en cualquier momento.</p>
                    <p>Las modificaciones entrarán en vigor desde su publicación en el sitio web.</p>
                    <p>El uso continuado de los servicios constituirá la aceptación de la versión vigente.</p>

                    <h5>18. Ley Aplicable y Jurisdicción</h5>
                    <p>Estos Términos y Condiciones se regirán e interpretarán de conformidad con las leyes del Estado de Florida, Estados Unidos de América, sin perjuicio de las normas imperativas que resulten aplicables.</p>
                    <p>Toda controversia derivada de estos Términos o de los servicios prestados por EnviarLatam LLC será sometida a la jurisdicción exclusiva de los tribunales estatales o federales competentes ubicados en el Estado de Florida, salvo disposición legal en contrario.</p>

                    <h5>19. Contacto</h5>
                    <p>Para consultas relacionadas con estos Términos y Condiciones o con los servicios de {brandName}, el Cliente podrá comunicarse con EnviarLatam LLC a través de los canales oficiales publicados en este sitio web.</p>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={onHide}
                    className={modalStyles.closeBtn}
                >
                    Aceptar y Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TermsModal;
